import React from "react";
import SecondaryHeader from "../../components/SecondaryHeader/SecondaryHeader";
import PayrollComponent from "../../components/PayrollComponent/PayrollComponent";

const Payroll: React.FC = () => {
  return (
    <div>
      <PayrollComponent />
    </div>
  );
};

export default Payroll;
